import { MessageSquare } from 'lucide-react';
import { SectionLabel } from '@/components/marketing/v2/SectionLabel';
import ContactFormV2 from '@/components/marketing/contact/v2/ContactFormV2';

const WHATSAPP_URL = 'https://wa.me/237656488879';

export default function DemoFormSectionV2() {
  return (
    <section id="formulaire" className="border-y-2 border-charcoal-800 bg-white py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-6 md:px-8">
        <div className="grid gap-12 md:grid-cols-[1.1fr_0.9fr] md:gap-14">
          {/* LEFT — Form */}
          <div>
            <SectionLabel>Demande de démo</SectionLabel>
            <h2 className="mt-3 font-marketing-display text-[clamp(32px,4.4vw,56px)] font-bold leading-[1] tracking-[-0.035em] text-charcoal-800">
              Réserve <span className="underline-lime">ta démo live.</span>
            </h2>
            <p className="mt-4 max-w-lg font-marketing-body text-[17px] text-charcoal-600">
              Dis-nous en quelques mots ton commerce et ce que tu veux voir. On te propose un
              créneau sous 24h ouvrables.
            </p>
            <div className="mt-8">
              <ContactFormV2 defaultSubject="demo" />
            </div>
          </div>

          {/* RIGHT — WhatsApp shortcut */}
          <div className="flex flex-col gap-5">
            <div className="border-[3px] border-charcoal-800 bg-charcoal-800 p-6 text-white shadow-neobrutal-lime-6 md:p-7 md:shadow-neobrutal-lime-10">
              <span className="font-marketing-mono text-[11px] font-medium uppercase tracking-[0.12em] text-lime-400">
                Le plus rapide
              </span>
              <h3 className="mt-3 font-marketing-display text-[22px] font-bold leading-[1.15] tracking-[-0.02em] text-white">
                Écris-nous sur WhatsApp
              </h3>
              <p className="mt-3 font-marketing-body text-[14px] leading-[1.55] text-charcoal-200">
                Réponse en moins de 30 minutes pendant les heures ouvrées (lun-ven, 8h-18h
                GMT+1). On planifie ta démo live directement dans la conversation.
              </p>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-6 inline-flex items-center gap-2 border-2 border-charcoal-800 bg-lime-500 px-5 py-3 font-marketing-display text-[14px] font-bold text-charcoal-800 shadow-neobrutal-4 transition-transform duration-150 hover:-translate-x-[2px] hover:-translate-y-[2px] hover:shadow-neobrutal-6"
              >
                <MessageSquare className="h-4 w-4" strokeWidth={2.5} />
                WhatsApp · +237 656 48 88 79
              </a>
            </div>

            <div className="border-2 border-charcoal-800 bg-paper p-7 shadow-neobrutal-4">
              <h3 className="font-marketing-display text-[16px] font-bold text-charcoal-800">
                Ce que tu peux demander pendant la démo
              </h3>
              <ul className="mt-4 space-y-2.5 font-marketing-body text-[14px] text-charcoal-600">
                <li>• Import de ton catalogue réel</li>
                <li>• Simulation d'une journée de vente hors ligne</li>
                <li>• Configuration crédit, troc ou module Bar</li>
                <li>• Questions tarifs et migration depuis ton outil actuel</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
